import { H5, LI, P, UL } from "../../../../../AbstractElements";
interface CommonBohoModalTitleProp {
  heading: string;
  subHeading: string;
  text:string
}
export const CommonBohoModalTitle = ({ heading, subHeading,text }: CommonBohoModalTitleProp) => {
  return (
    <>
      <UL className="simple-list d-flex dot-group pb-3 pt-0">
        <LI></LI>
        <LI></LI>
        <LI></LI>
      </UL>
      <div className="title-wrapper pb-3 modal-heading">
        <H5 className="theme-name mb-0">
          <span>{heading}</span>
          {subHeading}
        </H5>
        <P>{text}</P>
      </div>
    </>
  );
};


